
export default {
    increment(state){
        //setTimeout(() => state.count++, 2000);
        state.count++;
    },
    decrement(state){
        state.count--;
    },
    completeAll(state){
        state.todos.forEach(todo => todo.done = true);
    },
    deleteToDo(state, todo){
       state.todos.splice(state.todos.indexOf(todo), 1);
    },
    toggleToDo(state, todo){
       todo.done = ! todo.done;
    },
    addToDo(state, body){
        state.todos.push({body, done:false});
    }
}

// when following github vuex examples this export const mutations = {  doesn't work needed to change to export default